import { Constants } from '@constants';
import RoutesMappingConstants from '@constants/RoutesMappingConstants';

export const getCurrentEnvForAppLauncher = () => {
  const { hostname } = window.location;
  if (hostname.indexOf('toolsdv') !== -1 || hostname.indexOf('developer.gartner.com') !== -1) {
    return 'dev';
  }
  if (hostname.indexOf('toolsqa') !== -1) {
    return 'qa';
  }
  return 'prod';
};

export const getCapitaliseFirstLetter = (string) =>
  string[0].toUpperCase() + string.slice(1);

export const queryStringToObject = (query) => {
  const urlParams = new URLSearchParams(query);
  const result = {};
  urlParams.forEach((value, key) => {
    result[key] = value;
  });

  return result;
};

export const getToolsEnv = () => {
  const domain = window.location.hostname;
  if (Constants.APOLLO_HOST.DEV.indexOf(domain) !== -1) {
    return Constants.TOOLS_ENV.DEV;
  } if (Constants.APOLLO_HOST.QA.indexOf(domain) !== -1) {
    return Constants.TOOLS_ENV.QA;
  } if (Constants.APOLLO_HOST.DEMO.indexOf(domain) !== -1) {
    return Constants.TOOLS_ENV.DEMO;
  }
  return Constants.TOOLS_ENV.PROD;
};

export const getGCOMEnv = () => {
  const domain = window.location.hostname;
  if (Constants.APOLLO_HOST.DEV.indexOf(domain) !== -1) {
    return Constants.URLS.GARTNER_DEV;
  } if (Constants.APOLLO_HOST.QA.indexOf(domain) !== -1) {
    return Constants.URLS.GARTNER_QA;
  }
  return Constants.URLS.GARTNER;
};

export const getPageFromUrlForActisTracking = () => {
  try {
    const { pathname } = window.location;
    const { ROUTES_PAGE_MAPPING, PAGES } = RoutesMappingConstants;
    const guestProfilePathname = `${Constants.ROUTES.BASE_URL}${Constants.ROUTES.GUEST_PROFILE}`;
    let page = ROUTES_PAGE_MAPPING[pathname] || '';
    const { isWorkflow = false } = queryStringToObject(window?.location?.search);

    if (isWorkflow === 'true') {
      page = PAGES.WORKFLOW;
    }

    // Check if it's a guest profile because the pathname has a unique id at the end
    if (!page) {
      if (pathname.startsWith(guestProfilePathname)) {
        page = ROUTES_PAGE_MAPPING[guestProfilePathname] || '';
      }
    }

    // In case the mapping doesn't exist, fallback for it
    if (!page) {
      const delimiter = '_____';
      let pathnameWithoutBaseUrl = pathname.replace(Constants.ROUTES.BASE_URL, '');
      pathnameWithoutBaseUrl = pathnameWithoutBaseUrl
        .replace(/-/g, delimiter)
        .replace(/\//g, delimiter)
        .split(delimiter)
        .filter((item) => item.length > 0)
        .map(getCapitaliseFirstLetter)
        .join(' ');
      return pathnameWithoutBaseUrl;
    }

    return page;
  } catch (err) {
    console.error('ERROR in getPageFromUrlForActisTracking:', err);
    return '';
  }
};

export const isProd = () => getToolsEnv() === Constants.TOOLS_ENV.PROD;
